import React from 'react'
import { useError } from 'hooks'
import { textAreaType } from 'common/types'
import StyledTextArea, { StyledErrorTextArea } from './StyledTextArea'

const BasicTextArea = ({ defaultValue, ...rest }) => (
  <StyledTextArea data-initial={defaultValue} defaultValue={defaultValue} {...rest} />
)

const ErrorTextArea = ({ error: { field = '' } = {}, onChange, name, ...rest }) => {
  const [error, _onChange] = useError(field || name, onChange)

  return (
    <StyledErrorTextArea>
      <BasicTextArea className={error ? 'error' : ''} onChange={_onChange} name={name} {...rest} />
      {error && <div className="errorMsg">{error}</div>}
    </StyledErrorTextArea>
  )
}

const TextArea = ({ hasError, ...props }) => (hasError ? <ErrorTextArea {...props} /> : <BasicTextArea {...props} />)

TextArea.defaultProps = {
  spellCheck: false,
  onChange: () => {}, // Prevent warning/error about readOnly when setting only <form onChange>
}

TextArea.propTypes = textAreaType

export default TextArea
